import { useCallback, useEffect, useState } from 'react';
import { IEmpresas } from '../../interfaces/IEmpresas';
import { IEsteira } from '../../interfaces/IEsteira';
import EmpresasService from '../../services/EmpresasService';


function RelatorioStatus({ empresa }: { empresa: IEmpresas | undefined }) {

    const [esteiras, setEsteiras] = useState<IEsteira[]>([]);
    const [interval, setIntervalId] = useState<any>();

    const loadPage = useCallback(async (id: number) => {
        return await EmpresasService.obterEsteiras(id);
    }, [])

    const formatDate = useCallback((date: any) => {
        if (typeof(date) === 'object') {
            return date.toISOString().substring(0, 10).split('-').reverse().join('/');
        } else {
            return date.substring(0, 10).split('-').reverse().join('/');
        }
    }, []);

    useEffect(() => {
        if (empresa && empresa.id) {
            loadPage(empresa.id).then((result: IEsteira[]) => setEsteiras(result));
            setIntervalId((oldValue: any) => {
                if (!oldValue) {
                    return setInterval(() => {
                        loadPage(empresa.id).then((result: IEsteira[]) => setEsteiras(result));
                    }, 10000);
                }

                return oldValue;
            });
        }

        return () => {
            clearInterval(interval);
        }
    }, [loadPage, empresa]);

    return (
        <div className='row'>
            <div className='col-md-12 mt-6'>
                <h5>Aqui você consegue validar o progresso da sua importação</h5>
                <h5><i>As informações na tela são atualizadas de 10 em 10 segundos</i></h5>
            </div>
            <div className='col-md-12 mt-6'>
                <table className='table'>
                    <thead>
                        <tr>
                            <th scope='col'>Período Inicial</th>
                            <th scope='col'>Período Final</th>
                            <th scope='col'>Data da Importação</th>
                            <th scope='col'>Auditoria de tributos</th>
                            <th scope='col'>Auditoria geral</th>
                            <th scope='col'>Análise horizontal</th>
                            <th scope='col'>Auditoria de caixa e bancos</th>
                            <th scope='col'>Auditoria de Imobilizados</th>
                            <th scope='col'>Auditoria de Estoque</th>
                            <th scope='col'>Auditoria de Depreciação</th>
                        </tr>
                    </thead>
                    <tbody>
                        {esteiras.map((item) => (
                            <tr>
                                <th scope='row'>{item.periodoInicioString}</th>
                                <td>{item.periodoFimString}</td>
                                <td>{item.dataInsercao ? formatDate(item.dataInsercao) : 'Não possuí data de importação'}</td>
                                <td>
                                    <div className='progress'>
                                        <div className='progress-bar' role='progressbar' style={{ width: `${item.porcentagemRegra18 ?? 0}%` }} aria-valuenow={item.porcentagemRegra18 ?? 0} aria-valuemin={0} aria-valuemax={100}>{item.porcentagemRegra18 ?? 0}%</div>
                                    </div>
                                </td>
                                <td>
                                    <div className='progress'>
                                        <div className='progress-bar' role='progressbar' style={{ width: `${item.porcentagemConciliacaoGeral ?? 0}%` }} aria-valuenow={item.porcentagemConciliacaoGeral ?? 0} aria-valuemin={0} aria-valuemax={100}>{item.porcentagemConciliacaoGeral ?? 0}%</div>
                                    </div>
                                </td>
                                <td>
                                    <div className='progress'>
                                        <div className='progress-bar' role='progressbar' style={{ width: `${item.porcentagemConciliacaoGeral ?? 0}%` }} aria-valuenow={item.porcentagemConciliacaoGeral ?? 0} aria-valuemin={0} aria-valuemax={100}>{item.porcentagemConciliacaoGeral ?? 0}%</div>
                                    </div>
                                </td>
                                <td>
                                    <div className='progress'>
                                        <div className='progress-bar' role='progressbar' style={{ width: `${item.porcentagemBancoCaixa ?? 0}%` }} aria-valuenow={item.porcentagemBancoCaixa ?? 0} aria-valuemin={0} aria-valuemax={100}>{item.porcentagemBancoCaixa ?? 0}%</div>
                                    </div>
                                </td>
                                <td>
                                    <div className='progress'>
                                        <div className='progress-bar' role='progressbar' style={{ width: `${item.porcentagemImobilizado ?? 0}%` }} aria-valuenow={item.porcentagemImobilizado ?? 0} aria-valuemin={0} aria-valuemax={100}>{item.porcentagemImobilizado ?? 0}%</div>
                                    </div>
                                </td>
                                <td>
                                    <div className='progress'>
                                        <div className='progress-bar' role='progressbar' style={{ width: `${item.porcentagemEstoque ?? 0}%` }} aria-valuenow={item.porcentagemEstoque ?? 0} aria-valuemin={0} aria-valuemax={100}>{item.porcentagemEstoque ?? 0}%</div>
                                    </div>
                                </td>
                                <td>
                                    <div className='progress'>
                                        <div className='progress-bar' role='progressbar' style={{ width: `${item.porcentagemDepreciado ?? 0}%` }} aria-valuenow={item.porcentagemDepreciado ?? 0} aria-valuemin={0} aria-valuemax={100}>{item.porcentagemDepreciado ?? 0}%</div>
                                    </div>
                                </td>
                            </tr>
                        ))}
                        
                    </tbody>
                </table>
            </div>
        </div>

    );
};

export default RelatorioStatus;